import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { PositionTimeUnit, PositionType, } from '@annunciate/core';
import { updateCachedProgress } from '@annunciate/query';
export const useProgressUpdater = (content) => {
    const client = useQueryClient();
    return useCallback((value) => {
        if (!content)
            return;
        const position = {
            type: PositionType.TIME,
            unit: PositionTimeUnit.SECONDS,
            value,
        };
        updateCachedProgress(client, { contentId: content.id, position, sync: true });
    }, [
        client,
        content?.id,
    ]);
};
//# sourceMappingURL=useProgressUpdater.js.map